var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcoGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 45 303)",
    id: "KxzPTrh_kkunnVq4Q0rXi"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.85 0 0 -0.85 255.18 -3.36)",
    id: "zXyd6BF5Md147gl6r5pDT"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-853.5, -704.98)",
    d: "M 576.337 707.516 C 576.319 658.346 589.132 610.3489999999999 613.487 568.0409999999999 L 574 423.48 L 721.548 462.27200000000005 C 762.2 440.04200000000003 807.971 428.32800000000003 854.55 428.31000000000006 L 854.67 428.31000000000006 C 1008.0649999999999 428.31000000000006 1132.935 553.4760000000001 1133 707.2900000000001 C 1133.025 781.8380000000001 1104.1 851.932 1051.554 904.663 C 999 957.393 929.12 986.447 854.67 986.48 C 701.25 986.48 576.3979999999999 861.3340000000001 576.337 707.5160000000001 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.85 0 0 -0.85 255.18 -3.36)",
    id: "4W3xZCpc88lSsGwU_6xBE"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillOpacity: 0.2,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-853.5, -704.98)",
    d: "M 576.337 707.516 C 576.319 658.346 589.132 610.3489999999999 613.487 568.0409999999999 L 574 423.48 L 721.548 462.27200000000005 C 762.2 440.04200000000003 807.971 428.32800000000003 854.55 428.31000000000006 L 854.67 428.31000000000006 C 1008.0649999999999 428.31000000000006 1132.935 553.4760000000001 1133 707.2900000000001 C 1133.025 781.8380000000001 1104.1 851.932 1051.554 904.663 C 999 957.393 929.12 986.447 854.67 986.48 C 701.25 986.48 576.3979999999999 861.3340000000001 576.337 707.5160000000001 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.85 0 0 -0.85 255.31 -5.93)",
    id: "_JqvvGCVDWOt4KYIh8xJd"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 270.265,
    y1: 1.184,
    x2: 270.265,
    y2: 541.56
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(32,176,56)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(96,214,106)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-269.66, -271.98)",
    d: "M 2.325 274.421 C 2.3110000000000004 227.131 14.667000000000002 180.95499999999998 38.164 140.255 L 0.077 1.187 L 142.391 38.503 C 181.6 17.133 225.745 5.856 270.673 5.84 L 270.793 5.84 C 418.743 5.84 539.1790000000001 126.236 539.24 274.212 C 539.27 345.919 511.37 413.344 460.68100000000004 464.07 C 410.00100000000003 514.796 342.59700000000004 542.746 270.783 542.778 C 122.81500000000003 542.778 2.384999999999991 422.39200000000005 2.3249999999999886 274.42",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.85 0 0 -0.85 255.31 -5.93)",
    id: "LLpDYG-erl4YBtUE3ubaX"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 279.952,
    y1: 0.811,
    x2: 279.952,
    y2: 560.571
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(249,249,249)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_1)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-279.33, -281.32)",
    d: "M 2.407 283.847 C 2.3890000000000002 234.85099999999997 15.191 187.02299999999997 39.524 144.86399999999998 L 0.072 0.814 L 147.491 39.468 C 188.10700000000003 17.318000000000005 233.83700000000002 5.6440000000000055 280.376 5.6270000000000024 L 280.496 5.6270000000000024 C 433.756 5.6270000000000024 558.516 130.351 558.5809999999999 283.62100000000004 C 558.6069999999999 357.90700000000004 529.7069999999999 427.75300000000004 477.2069999999999 480.29900000000004 C 424.6999999999999 532.8430000000001 354.88099999999986 561.793 280.49599999999987 561.827 C 127.21099999999987 561.827 2.467999999999847 437.123 2.4059999999998922 283.847 z M 90.196 152.123 L 84.693 160.863 C 61.555 197.653 49.34 240.17 49.36 283.828 C 49.409 411.227 153.09 514.872 280.584 514.872 C 342.324 514.847 400.349 490.782 443.993 447.1089999999999 C 487.632 403.4389999999999 511.646 345.3829999999999 511.628 283.63999999999993 C 511.574 156.2369999999999 407.889 52.57699999999994 280.49699999999996 52.57699999999994 L 280.407 52.57699999999994 C 238.92499999999998 52.59899999999994 198.24499999999998 63.73599999999994 162.765 84.79099999999994 L 154.321 89.79499999999994 L 66.84 66.86 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.85 0 0 0.85 256.23 -5.88)",
    id: "HSyXoY2omfo6g1qTw2q3V"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-312.03, -305.57)",
    d: "M 242.63 186.78 C 237.42499999999998 175.21 231.946 174.977 226.994 174.774 C 222.944 174.601 218.307 174.612 213.678 174.612 C 209.046 174.612 201.517 176.352 195.151 183.305 C 188.781 190.258 170.829 207.066 170.829 241.252 C 170.829 275.442 195.73000000000002 308.474 199.20100000000002 313.11400000000003 C 202.675 317.74800000000005 247.27100000000002 390.14200000000005 317.89500000000004 417.994 C 376.591 441.14000000000004 388.535 436.53600000000006 401.27500000000003 435.37800000000004 C 414.01500000000004 434.22 442.38500000000005 418.57300000000004 448.175 402.34800000000007 C 453.966 386.12500000000006 453.966 372.2200000000001 452.229 369.3130000000001 C 450.491 366.4170000000001 445.859 364.6800000000001 438.90999999999997 361.2050000000001 C 431.96 357.7300000000001 397.79999999999995 340.9180000000001 391.42999999999995 338.6020000000001 C 385.05999999999995 336.2860000000001 380.42699999999996 335.1280000000001 375.79499999999996 342.0840000000001 C 371.162 349.0340000000001 357.85499999999996 364.6800000000001 353.799 369.31400000000014 C 349.746 373.9570000000001 345.693 374.5360000000001 338.743 371.06100000000015 C 331.794 367.57600000000014 309.415 360.24600000000015 282.867 336.57600000000014 C 262.211 318.16000000000014 248.26700000000002 295.41600000000017 244.211 288.46000000000015 C 240.15800000000002 281.51000000000016 243.77800000000002 277.74600000000015 247.263 274.28200000000015 C 250.383 271.16900000000015 254.213 266.17200000000014 257.687 262.11400000000015 C 261.154 258.05700000000013 262.313 255.16100000000014 264.629 250.52800000000013 C 266.945 245.88800000000015 265.78700000000003 241.83000000000013 264.05 238.35600000000014 C 262.313 234.88100000000014 248.80900000000003 200.51800000000014 242.63 186.78000000000014",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcoGreen);
export default __webpack_public_path__ + "static/media/whatsapp-ico_green.7f22420b5f32b383bdcffed3e843c4e0.svg";
export { ForwardRef as ReactComponent };